import { differenceInCalendarDays, format } from "date-fns";

const MINUTES_PER_DAY = 1440;
export const DEFAULT_EXPIRATION_TIME = 30 * MINUTES_PER_DAY;
// How many tokens show before "Show all". Change this number to adjust.
export const MAX_VISIBLE_TOKENS = 5;

/** Whole local days, so a custom date and the matching preset send the same figure. */
export const minutesUntil = (date: Date): number =>
  differenceInCalendarDays(date, new Date()) * MINUTES_PER_DAY;

export const formatDay = (date: Date): string => format(date, "dd/MM/yyyy");

export const relativeDay = (date: Date): string => {
  const n = differenceInCalendarDays(date, new Date());
  if (n === 0) return "Today";
  if (n === 1) return "Tomorrow";
  if (n === -1) return "Yesterday";
  return n > 0 ? `in ${n} days` : `${-n} days ago`;
};

export const normalizeName = (name: string): string =>
  name.trim().replace(/\s+/g, " ").toLowerCase();
